module.exports = __webpack_public_path__ + "static/media/default-0.42eaec1e.svg";